import { createFileRoute } from "@tanstack/react-router"
import TripCheckListsPage from "@/pages/TripCheckListsPage"
import { NotFound } from "@/components/NotFound"
import { useCanonicalId } from "@/lib/hooks/use-canonical-id"

function ChecklistsRoute() {
  const { tripId: param } = Route.useParams()
  const tripId = useCanonicalId(`trip`, param)
  if (tripId === undefined) return null
  if (tripId === null) return <NotFound />
  return <TripCheckListsPage tripId={tripId} />
}

export const Route = createFileRoute(
  `/_authenticated/trip/$slug/$tripId/checklists`
)({
  component: ChecklistsRoute,
})
